import Collapsible from "app/components/Collapsible/Collapsible";
import type { CompetitionType } from "app/types/competitionType";
import has from "lodash/has";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import { usePrevious } from "../../hooks/usePrevious/usePrevious";
import PopularEventCellMobile from "../PopularEventCellMobile/PopularEventCellMobile";
import "./CompetitionCellMobile.scss";
const CompetitionCellHeaderMobile = React.lazy(
  () =>
    import(
      "./components/CompetitionCellHeaderMobile/CompetitionCellHeaderMobile"
    )
);
type Props = {
  data: CompetitionType;
  setCompetition: (...args: Array<any>) => any;
  setCompetitionWithFavouritesList: (...args: Array<any>) => any;
  history: any;
  resizeCell: (...args: Array<any>) => any;
  competitionIndex: number;
  disableFilterTab: boolean;
};

const CompetitionCellMobile: React.FC<Props> = ({
  data,
  setCompetition,
  setCompetitionWithFavouritesList,
  resizeCell,
  competitionIndex,
  disableFilterTab,
}) => {
  const prevProps = usePrevious({
    data,
    setCompetition,
    setCompetitionWithFavouritesList,
    resizeCell,
    competitionIndex,
    disableFilterTab,
  });

  useEffect(() => {
    if (data.isActive === undefined) {
      setCompetition({ ...data, isActive: true });
    }
  }, []);

  useEffect(() => {
    const currentNumberOfEvents = data && data.events.length;
    const prevNumberOfEvents = prevProps?.data && prevProps.data.events.length;

    if (
      prevNumberOfEvents &&
      currentNumberOfEvents &&
      prevNumberOfEvents !== currentNumberOfEvents
    ) {
      resizeCell(competitionIndex);
    }
  }, [data]);

  const handleToggleEvents = () => {
    let competition = { ...data };

    if (competition.isActive != null) {
      competition.isActive = !competition.isActive;
    } else {
      competition.isActive = true;
    }

    setCompetition(competition);
    resizeCell(competitionIndex);
  };

  if (!has(data, "isActive")) {
    data.isActive = true;
  }

  return (
    <VisibilitySensor>
      <Collapsible
        status={"open"}
        suspended={<div className="suspended__text--event">{"open"}</div>}
        header={
          <React.Suspense fallback={<div className="fallback">loading...</div>}>
            <CompetitionCellHeaderMobile
              data={data}
              disableFilterTab={disableFilterTab}
              toggleEvents={handleToggleEvents}
            />
          </React.Suspense>
        }
        content={data.events.map(event => (
          <PopularEventCellMobile
            data={event}
            competitionIndex={competitionIndex}
            key={event.id}
            resizeCell={resizeCell}
            setCompetitionWithFavouritesList={setCompetitionWithFavouritesList}
          />
        ))}
        isActive={data.isActive}
        disableAnimations
      />
    </VisibilitySensor>
  );
};

const mapStateToProps = state => ({
  disableFilterTab: state.competitionListModel.disableFilterTab,
});

function mapDispatchToProps(dispatch) {
  return {
    setCompetition: (competition: CompetitionType) =>
      dispatch.competitionListModel.updateCompetitionInList(competition),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompetitionCellMobile);
